import env from '../BsGetEnv'
import bsGetXcx from './../BsGetXcx';
function getQueryString(name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  const r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return '';
}
function fomatTime(num) {
  return num < 10 ? ('0' + num) : num.toString()
}
function getNowtime() {
  const date = new Date()
  const yyyy = fomatTime(date.getFullYear())
  const MM = fomatTime(date.getMonth() + 1)
  const dd = fomatTime(date.getDate())
  const hh = fomatTime(date.getHours())
  const mm = fomatTime(date.getMinutes())
  const ss = fomatTime(date.getSeconds())
  return yyyy + MM + dd + hh + mm + ss
}

function get_cookie(name) {
  const reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
  let arr = document.cookie.match(reg); 
  return arr ? unescape(arr[2]) : ''
}

function set_cookie(name, value, time) { 
  let domain = env.isEnVlocal? '': ';domain=.didachuxing.com'
  document.cookie = name + '=' + value + '; max-age=' + (time||7)*24*60*60 + domain;
}

function isObject(obj){
    return Object.prototype.toString.call(obj) === '[object Object]';
}

function isString(obj){
    return Object.prototype.toString.call(obj) === '[object String]';
}

function isNumber(obj){
  return Object.prototype.toString.call(obj) === '[object Number]';
}

function isBoolean(obj){
  return Object.prototype.toString.call(obj) === '[object Boolean]';
}

function isArray(obj){
  return Object.prototype.toString.call(obj) === '[object Array]';
}

function isFunction(obj){
  return Object.prototype.toString.call(obj) === '[object Function]';
}
// 判断版本号
// v1 > v2 ==> 1
// v1 < v2 ==> -1
// v1 == v2 ==> 0
function compareVersion(v1, v2)  {
  v1 = v1.split('.');
  v2 = v2.split('.');
  const len = Math.max(v1.length, v2.length);
  while (v1.length < len) {
    v1.push('0');
  }
  while (v2.length < len) {
    v2.push('0');
  }
  for (let i = 0; i < len; i++) {
    const num1 = parseInt(v1[i], 10);
    const num2 = parseInt(v2[i], 10);
    if (num1 > num2) {
      return 1;
    } else if (num1 < num2) {
      return -1;
    }
  }
  return 0;
}


function getQuery(str) {
    var theRequest = {};
    var strs = (str || location.search.substr(1)).split("&");
    for (var i = 0; i < strs.length; i++) {
        let query = strs[i].split("=");
        if(query.length === 2){
          theRequest[query[0]] = decodeURIComponent(query[1]);
        }
    }
    return theRequest;
}

function stringify(obj){
  function dep(obj,key){
    var params ='';
    if(isObject(obj)){
      Object.keys(obj).forEach(item=>{
        params += dep(obj[item], key ? `${key}[${item}]`:`${item}`)
      })
    }else if(isArray(obj)){
      for(var i = 0 ; i < obj.length; i++){
        params += dep(obj[i], key ? `${key}[${i}]`:`${i}`)
      }
    } else if(!isFunction(obj)){
      return key + `=` + obj + `&`;
    }
    return params
  }
  if(!obj) return '';
  let params = dep(obj);
  return params.substring(0, params.lastIndexOf('&'));
}

const currentEnv = (async function (){
  if(env.isDidaPinche){
      return 'carpoolapp' // 顺风车app
  }else if(env.isDidaTaxi){
      return 'taxiapp' // 顺风车app
  }
  let appId = getQueryString('appId')
  let xcx = await bsGetXcx();
  if(xcx.isWx){
      return appId || 'wx7f9416391161a1a0'
  } else if(xcx.isAli){
      return appId || '2019112669404960'
  }else if(env.inWechat){
      return 'carpool_wx' // 微信环境
  }else if(env.isAlipay){
      return 'carpool_ali' // 支付宝环境
  }
})()

function getQueryVariable(name, hash){
  const reg = new RegExp("(^|&)" + name+ "=([^&]*)(&|$)", "i");
  const result = hash.match(reg);
  return result !==null ? decodeURI(result[2]) : ''
}
/**
 * 时间转换
 * @param timestamp 时间间隔，ms
 * @returns 根据时间间隔得时间戳，返回对象{日，时，分，秒}，一般用于倒计时，一位数时返回 0 占位得两位数字
 * **/
function formaTimeDuration(timestamp){
  // const milliseconds = timestamp % 1000;
  const seconds = Math.floor((timestamp / 1000) % 60).toString().padStart(2, '0')
  const minutes = Math.floor((timestamp / (1000 * 60)) % 60).toString().padStart(2, '0')
  const hours = Math.floor((timestamp / (1000 * 60 * 60)) % 24).toString().padStart(2, '0')
  const days = Math.floor(timestamp / (1000 * 60 * 60 * 24)).toString().padStart(2, '0')
  return {
    days,
    hours,
    minutes,
    seconds
  }
}
/***
 * 时间转换
 * @param timestamp 时间戳或者日期
 * @returns 根据时间戳或者日期，返回对象{年，月，日，时，分，秒}，一般用于时间格式化，一位数时返回 0 占位得两位数字
*/
function formatTimestamp(timestamp) {
  const date = new Date(timestamp)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')
  return {
    year,
    month,
    day,
    hours,
    minutes,
    seconds
  }
}

/**
 * 数值转换，面额转换，百分比转换，折扣转换
 * @param value 要转换得金额，单位 分
 * @param type  ['default', 'money', 'percent'， 'discount']
 * **/
function formatNumber(value, type) {
  if(type === 'money') {
    let result = Number(value)
    result = result / 100
    if (Number.isInteger(result)) {
        return result.toFixed(0) // 返回整数形式
    } else {
        return result.toFixed(2).replace(/\.?0+$/, '') // 返回去除末尾多余0的数值
    }
  } else if(type === 'percent') {
    return  Number(value) * 100
  } else if(type === 'discount') {
    return  (Number(value) * 1000 / 100)
  } else {
    return value
  }
  
}

export default {
  queryString: getQueryString,
  nowTime: getNowtime,
  getCookie: get_cookie,
  setCookie: set_cookie,
  isObject,
  isString,
  isNumber,
  isBoolean,
  isArray,
  isFunction,
  getQuery,
  compareVersion,
  stringify,
  currentEnv,
  getQueryVariable,
  formaTimeDuration,
  formatTimestamp,
  formatNumber
}